// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"736":"chartjs","744":"actioncable"}[chunkId] || chunkId) + "-" + {"19":"dfc1c13e29bf0349a4bc","736":"dfe39a1e2d83c2403dc1","744":"a2d0c7e22f103d61f631"}[chunkId] + ".chunk.js";
};